import type { TFunction } from 'i18next';

import type { ProviderAccount } from '@/domain/providerConfig';

/**
 * An account's name for people. An account row's provider name can name a customer, so the
 * server names a neutral display key for each account type it knows; anything else reads as a
 * neutral type, never as the provider name.
 */
export function accountLabel(t: TFunction, account: Pick<ProviderAccount, 'displayKey'>): string {
    const fallback = t('providerConfig.accounts.unknownProvider');
    if (account.displayKey === null) return fallback;
    return t(`providerConfig.accounts.types.${account.displayKey}`, { defaultValue: fallback });
}
